import { ButtonBase, styled as muiStyled } from '@mui/material'

export const FAQSidebarLayoutContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
    padding: 28px 16px;
    background: #f8fafc;
    min-height: 100%;
`,
)

export const FAQSidebarLayoutFAQsContainer = muiStyled('div')(
  ({ theme }) => `
display: grid;
grid-template-columns: 1fr;
width: 100%;
gap: 18px;
@media(min-width: ${theme.breakpoints.values.md}px){
  gap: 20px;
    grid-template-columns: 1fr 2fr;
}
`,
)

export const FAQHeader = muiStyled('div')(
  ({ theme }) => `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;

    .title{
      font-size: 30px;
      font-weight: 700;
      color: #0f172a;
      margin: 0;
    }
    .subtext{
      font-size: 14px;
      color: #475569;
      margin: 4px 0 0 0;
    }
`,
)

export const FAQContentCard = muiStyled('div')(
  ({ theme }) => `
    width: 100%;
    background: #fff;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
    border-radius: 14px;
    padding: 12px;
    @media(min-width: ${theme.breakpoints.values.md}px){
      padding: 18px 20px;
    }
`,
)

export const FAQCategoriesContainerDefault = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  @media(min-width: ${theme.breakpoints.values.md}px){
    margin: 0;
  }
`,
)

export const FAQCategoriesContainerWithDropDownButton = muiStyled('div')(
  ({ theme }) => `
    background: #f3f3f3;
    display:flex;
    border-radius: 7px;
    flex-direction: column;
    overflow: hidden;
    margin: 6px 0;
    @media(min-width: ${theme.breakpoints.values.md}px){
      margin: 0;
      background: transparent;
      border-radius: unset;
      overflow: unset;
    }
`,
)

export const FAQCategoryItem = muiStyled(ButtonBase)(
  ({ theme, selected }) => `
  padding: 14px 22px;
  border-bottom: 1px solid #dbdbdb;
  justify-content: flex-start;
  background: ${selected ? '#0000000d' : 'transparent'};
  display: flex;
  align-items: center;
  gap: 8px;

 .category-name{
      font-size: 16px;
      font-weight: 600;
      margin: 0px;
      color: #0f172a;
 }

 .category-count{
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 999px;
    background: #e2e8f0;
    color: #0f172a;
 }
`,
)

export const FAQItemsContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`,
)
export const FAQItemsContainerTwoColumn = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  gap: 10px;
  width: 100%;
  flex-direction: column;
  @media(min-width: ${theme.breakpoints.values.xl}px){
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: start;
}
`,
)

export const FAQEmptyState = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 24px;
    color: #475569;
    p{
      margin: 0;
      font-size: 14px;
    }
`,
)

// export const FAQItemContainer
